import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_hyqrkm9hrr: FaireBrandEntity = {
  token: "b_hyqrkm9hrr",
  type: "brand",
  name: "Jane and Bloom USA",
  avatarUrl:
    "https://cdn.faire.com/fastly/99142a7ac40d61b62d0d0a087e3b6acafff7f50c9c26620ace25748dfba4be19.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/a71d2ae0c2bad08f80e958a6a0b7310433a2ffb1b6699119167b8ff93e447793.png",
  logoUrl:
    "https://cdn.faire.com/fastly/99142a7ac40d61b62d0d0a087e3b6acafff7f50c9c26620ace25748dfba4be19.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a71d2ae0c2bad08f80e958a6a0b7310433a2ffb1b6699119167b8ff93e447793.png",
  location: "San Francisco, CA, USA",
  minimumOrderDollars: 40,
  rating: 0,
  reviewCount: 0,
  isInsider: true,
  description:
    "Jane & Bloom’s mission is to help businesses offer meaningful, thoughtfully crafted gifts that bring comfort, joy, and a sense of care to every customer experience.\nDesigned for spas, salons, florists, gift boutiques, and lifestyle retailers, our spa gift sets are created to complement wellness-focused spaces, elevate gifting moments, and offer customers a beautiful way to celebrate self-care and connection.\nWe take pride in our unique aesthetic designs and in creating gifts that customers remember — and return for. \nEach design is created exclusively by our founder, Jane, with thoughtful attention to detail and a heartfelt intention to make every woman feel cared for, appreciated, and celebrated.\nWith every box, we focus on quality, aesthetic presentation, and thoughtful details — helping our partners provide gifts that feel personal, calming, and memorable.\nCrafted with care, Jane & Bloom is here to support businesses in sharing wellness, kindness, and the beauty of simple everyday moments.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:16.364Z",
    importedBy: "entity-db-cli",
  },
};
